import { ParkAsset } from './asset.models';
import { ConflictMap, RemovalMap, RemovalType, Conflict } from './conflict.models';
import { Segment } from './eligibility.models';
import { Entitlement } from './entitlement.models';
import { Guest } from './guest.models';
import { Offer } from './offer.models';

export interface Session {

    // party
    selectedGuests?: Guest[];

    // date & park
    selectedDate?: string;
    selectedPark?: ParkAsset;

    // segments
    eligibleSegments?: Segment[];
    selectedSegment?: Segment;

    // offer
    selectedOffer?: Offer;
    originalOffer?: Offer;
    hasOfferChanged?: boolean;
    offersetId?: string;

    // review & confirm
    createdEntitlement?: Entitlement;

    // details & mods
    selectedEntitlement?: Entitlement;

    // conflicts
    resolvedGuests?: Guest[];
    unresolvedGuests?: Guest[];
    originalGuests?: Guest[];
    conflicts?: Conflict[];
    conflictMap?: ConflictMap;
    removalMap?: RemovalMap;
    removalType?: RemovalType;
    removedGuests?: Guest[];
    nextView?: ViewName;
    nextSession?: Session;

}

export enum ViewName {
    CREATE_PARTY = 'CREATE_PARTY',
    SELECT_DATE_AND_PARK = 'SELECT_DATE_AND_PARK',
    SEGMENT_DETECTION = 'SEGMENT_DETECTION',
    UNABLE_TO_RESERVE = 'UNABLE_TO_RESERVE',
    SELECT_TIME = 'SELECT_TIME',
    REVIEW_AND_CONFIRM = 'REVIEW_AND_CONFIRM',
    CONFIRMATION = 'CONFIRMATION',
    RESERVATION_DETAILS = 'RESERVATION_DETAILS',
    CANCEL_PARTY = 'CANCEL_PARTY',
    CONFLICT = 'CONFLICT',
    ERROR = 'ERROR'
}

export type Route = string;

export type SessionMap = {
    [key in ViewName]?: Session
};

export enum Intent {
    BOOKING = 'BOOKING',
    CANCEL = 'CANCEL'
}
